import { Location } from 'history';
import { PageRef } from 'mk2/apps/forum/schemas';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';
import { OrderBy } from './GroupSubscribedFeed.reducers';
import { ScrollToPosition } from './GroupSubscribedFeedPage';

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface GroupSubscribedFeedFetchAction extends Action {
    readonly pageRef: PageRef;
    readonly orderBy: OrderBy;
}

/////////////////////////////////////////////////////////////////////
// Group subscribed feed load
export const GROUP_SUBSCRIBED_FEED_FETCH_TRIGGER = 'GROUP_SUBSCRIBED_FEED_FETCH_TRIGGER';
export interface GroupSubscribedFeedFetchTriggerAction extends GroupSubscribedFeedFetchAction {
    readonly type: typeof GROUP_SUBSCRIBED_FEED_FETCH_TRIGGER;
    readonly currentUrl: Location;
    readonly numPostsBeforeLoad: number;
}
export const GROUP_SUBSCRIBED_FEED_FETCH_REQUEST = 'GROUP_SUBSCRIBED_FEED_FETCH_REQUEST';
export interface GroupSubscribedFeedFetchRequestAction extends GroupSubscribedFeedFetchAction, APIRequestAction {
    readonly type: typeof GROUP_SUBSCRIBED_FEED_FETCH_REQUEST;
}
export interface GroupSubscribedFeedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        complaints: number[];
        group: number;
        posts: number[];
        moderators: number[];
    };
}
export const GROUP_SUBSCRIBED_FEED_FETCH_SUCCESS = 'GROUP_SUBSCRIBED_FEED_FETCH_SUCCESS';
export interface GroupSubscribedFeedFetchSuccessAction extends GroupSubscribedFeedFetchAction, APISuccessAction<GroupSubscribedFeedFetchNormalizedResponse> {
    readonly type: typeof GROUP_SUBSCRIBED_FEED_FETCH_SUCCESS;
    readonly page: number;
    readonly numberOfPages: number;
    readonly count: number;
    readonly memberships: number[];
    readonly groupsCount: number;
}
export const GROUP_SUBSCRIBED_FEED_FETCH_FAILURE = 'GROUP_SUBSCRIBED_FEED_FETCH_FAILURE';
export interface GroupSubscribedFeedFetchFailureAction extends GroupSubscribedFeedFetchAction, APIFailureAction {
    readonly type: typeof GROUP_SUBSCRIBED_FEED_FETCH_FAILURE;
}

export const groupSubscribedFeedFetchTrigger =
    (orderBy: OrderBy, pageRef: PageRef, currentUrl: Location, numCommentsBeforeLoad: number = 0): GroupSubscribedFeedFetchTriggerAction => ({
        type: GROUP_SUBSCRIBED_FEED_FETCH_TRIGGER, orderBy, pageRef, currentUrl, numPostsBeforeLoad: numCommentsBeforeLoad,
    });
export const groupSubscribedFeedFetchApi = {
    request: (orderBy: OrderBy, pageRef: PageRef): GroupSubscribedFeedFetchRequestAction => ({
        type: GROUP_SUBSCRIBED_FEED_FETCH_REQUEST, orderBy, pageRef,
    }),
    success: (
        orderBy: OrderBy, pageRef: PageRef, page: number, numberOfPages: number, count: number,
        response: GroupSubscribedFeedFetchNormalizedResponse, memberships: number[], groupsCount: number,
    ): GroupSubscribedFeedFetchSuccessAction => ({
        type: GROUP_SUBSCRIBED_FEED_FETCH_SUCCESS, orderBy, pageRef, page, numberOfPages, count,
        response, memberships, groupsCount,
    }),
    failure: (orderBy: OrderBy, pageRef: PageRef, error: any): GroupSubscribedFeedFetchFailureAction => ({
        type: GROUP_SUBSCRIBED_FEED_FETCH_FAILURE, orderBy, pageRef, error,
    }),
};

/////////////////////////////////////////////////////////////////////
// Group feed - scrollto

export const GROUP_SUBSCRIBED_FEED_SCROLLTO_TRIGGER = 'GROUP_SUBSCRIBED_FEED_SCROLLTO_TRIGGER';
export interface GroupSubscribedFeedScrollToTriggerAction {
    readonly type: typeof GROUP_SUBSCRIBED_FEED_SCROLLTO_TRIGGER;
    readonly scrollto: ScrollToPosition;
}

export const groupSubscribedFeedScrollToTrigger = (scrollto: ScrollToPosition): GroupSubscribedFeedScrollToTriggerAction => ({
    type: GROUP_SUBSCRIBED_FEED_SCROLLTO_TRIGGER, scrollto,
});
